import axios from 'axios';

// Trigger a browser download for a Blob WITHOUT navigating away from the current
// page. Uses a temporary anchor with the `download` attribute.
export function saveBlob(blob, filename) {
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename || 'download';
  a.rel = 'noopener';
  document.body.appendChild(a);
  a.click();
  a.remove();
  setTimeout(() => URL.revokeObjectURL(url), 1500);
}

function filenameFromUrl(u, fallback) {
  try {
    const name = decodeURIComponent(String(u).split('?')[0].split('/').pop() || '');
    return name || fallback || 'download';
  } catch {
    return fallback || 'download';
  }
}

// Fetch a server file (relative `/api/...` or absolute URL) as a blob via the
// app's authenticated axios instance, then download it. This replaces
// `window.open(url)` which the browser blocks as a popup when called after an
// `await` and can bounce the SPA to another route.
export async function downloadFileUrl(fileUrl, filename) {
  if (!fileUrl) throw new Error('No file URL');
  const response = await axios.get(fileUrl, { responseType: 'blob' });
  saveBlob(response.data, filename || filenameFromUrl(fileUrl, filename));
}
